'use strict';

import FooterAnimate from './components/FooterAnimate';
new FooterAnimate(); // eslint-disable-line no-new
import Modal from './components/Modal';
new Modal('flyout-cart'); // eslint-disable-line no-new
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('org/product/detailNPI'));
    processInclude(require('org/product/arlovariantvideo'));

    // eslint-disable-next-line require-jsdoc
    function pairDevicesCards() {
        $('.pair-devices-cards').slick({
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        infinite: true,
                        speed: 300,
                        dots: true,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 520,
                    settings: {
                        infinite: true,
                        speed: 300,
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    // eslint-disable-next-line require-jsdoc
    function pairDevicesDestroySlickSlider() {
        if ($('.pair-devices-cards').hasClass('slick-initialized')) {
            $('.pair-devices-cards').slick('unslick');
        }
    }

    if ($(window).width() < 960) {
        pairDevicesCards();
    }

    $(window).on('resize', function () {
        if ($(window).width() < 960) {
            pairDevicesCards();
        } else {
            pairDevicesDestroySlickSlider();
        }
    });
});

